module.exports = __webpack_public_path__ + "static/media/20160212_Rankin_Mural_0134.069e8bb1.jpg";